import React from 'react'
import '../Timesheets/EditInvoice/edit-invoice.css'
import './invoice-view-master.css'

import axios from 'axios';
import { baseUrl } from '../assets/Animations';

const InvoiceViewMaster = (props) => {

    const [schoolName, setSchoolName] = React.useState('')
    const [schoolLocation, setSchoolLocation] = React.useState('')
    const [schoolPhoneNumber, setSchoolPhoneNumber] = React.useState('')
    const [schoolWebsite, setSchoolWebsite] = React.useState('')
    const [schoolLogoURL, setSchoolLogoURL] = React.useState('')
    const [invoiceDate, setInvoiceDate] = React.useState('')
    const [paymentDue, setPaymentDue] = React.useState('')
    const [familyInfoPopup, setFamilyInfoPopup] = React.useState(false)
    const [onboardDate, setOnboardDate] = React.useState('')
    const [currentActiveStudents, setCurrentActiveStudents] = React.useState([])
    const [familyInfo, setFamilyInfo] = React.useState(false)

    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
      if(props.invoice.school === 'mma') {
        setSchoolLocation('Boulder, Colorado')
        setSchoolLogoURL('https://www.mountainsidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(720) 432-6476')
        setSchoolWebsite('www.mountainsidemusicacademy.com')
        setSchoolName('Mountainside Music Academy')
      }
      if(props.invoice.school === 'lsma') {
        setSchoolLocation('Plymouth, Minnesota')
        setSchoolLogoURL('https://www.lakesidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(763) 200-4122')
        setSchoolWebsite('www.lakesidemusicacademy.com')
        setSchoolName('Lakeside Music Academy')
      }
      if(props.invoice.school === 'tma') {
        setSchoolLocation('Ann Arbor, Michigan')
        setSchoolLogoURL('https://www.treesidemusicacademy.com/logo.png')
        setSchoolPhoneNumber('(734) 707-9174')
        setSchoolWebsite('www.treesidemusicacademy.com')
        setSchoolName('Treeside Music Academy')
      }
      if(props.invoice.school === 'glma') {
        setSchoolLocation('Evanston, Illinois')
        setSchoolLogoURL('https://www.greatlakesmusicacademy.com/logo.png')
        setSchoolPhoneNumber('(312) 767-8117')
        setSchoolWebsite('www.greatlakesmusicacademy.com')
        setSchoolName('Great Lakes Music Academy')
      }
      createInvoiceDateAndDueDate()
      getFamilyInfo()
      openingAnimation()
    }, [])

    const openingAnimation = () => {
        document.getElementById('invoice-view-master__wrapper').style.top = "10px"
        document.getElementById('invoice-view-master__wrapper').style.opacity = "1"
        document.getElementById("create-timesheet-wrapper").style.opacity = "1"
    }

    const closingAnimation = () => {
        document.getElementById('invoice-view-master__wrapper').style.top = "-810px"
        document.getElementById('invoice-view-master__wrapper').style.opacity = 0
        document.getElementById("create-timesheet-wrapper").style.opacity = 0
    }

    const getFamilyInfo = () => {
        axios.get(`${baseUrl}/school-management/${props.invoice.familyId}`)
        .then(res => setFamilyInfo(res.data))
        .catch((err) => console.log(err))
    }

    const createInvoiceDateAndDueDate = () => {
      let theDate = new Date()
      let myISODate = theDate.toISOString().split('T')[0]
      let invoiceDate;
      let paymentDue;
      if(myISODate.split('-')[2] > 21) {
        let flippedDate = new Date(theDate.getFullYear(), ((theDate.getMonth())%12 + 1), 1)
        invoiceDate = flippedDate.toISOString().split('T')[0]
        paymentDue = new Date(theDate.getFullYear(), ((theDate.getMonth())%12 + 1), flippedDate.getDate() + 7).toISOString().split('T')[0]
      } else {
        invoiceDate = theDate.toISOString().split('T')[0]
        paymentDue = new Date(theDate.setDate(theDate.getDate() + 7)).toISOString().split('T')[0]
      }
      setInvoiceDate(invoiceDate)
      setPaymentDue(paymentDue)
    }

    const findStudentRate = (nameOnInvoice, lengthOfLesson) => {
      let found = false
      if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61) {
        found = true
        if(parseInt(lengthOfLesson) === 31) {
          return 25
        } else if (parseInt(lengthOfLesson) === 46) {
          return 35
        } else if (parseInt(lengthOfLesson) === 61) {
          return 45
        }
      } else {
        if(familyInfo) {
            for(let i = 0; i < familyInfo.students.length; i++) {
                if(familyInfo.students[i].studentName === nameOnInvoice) {
                    found = true
                    if(!familyInfo.students[i].allRates) {
                      return familyInfo.students[i].lessonRate
                    } else {
                      return familyInfo.students[i].allRates[lengthOfLesson]
                    }
                }
            }
        }
      }
      if(!found) {
          //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
          return 0
      }
    }

    const estimateCharge = () => {
        let total = 0
        for(let i = 0; i < props.invoice.lessonsToBeBilled.length; i++) {
            total = Math.floor(parseInt(total) + parseInt(findStudentRate(props.invoice.lessonsToBeBilled[i].studentName, props.invoice.lessonsToBeBilled[i].lessonLength)))
        }
        for(let i = 0; i < props.invoice.extrasToBeBilled.length; i++) {
          total = Math.floor(parseInt(total) + parseInt(props.invoice.extrasToBeBilled[i].amount))
        }
        return total
    }


    const toggleFamilyPopup = (bool) => {
      if(onboardDate === '') {
        axios.get(`${baseUrl}/family-lookup/${props.invoice.waveCustomerId}`, myHeader)
        .then((res) => {
          let myDate = new Date(res.data.onboardDate).toISOString().split('T')[0]
          setOnboardDate(myDate)
          let activeStudents = []
          for(let i = 0; i < res.data.students.length; i++) {
            if(res.data.students[i].studentStatus === 'Active') {
              activeStudents.push(res.data.students[i].studentName)
            }
          }
          setCurrentActiveStudents(activeStudents)
        })
      }
      setFamilyInfoPopup(bool)
    }

    const tryToClose = (id) => {
        if(id === "create-timesheet-wrapper") {
            closingAnimation()
            setTimeout(() => {
                props.setInvoiceView(false)
            }, 400)
        }
    }

    return(
        <div className="create-timesheet-wrapper invoice-view-master-wrapper" id="create-timesheet-wrapper" onClick={(e) => tryToClose(e.target.id)}>
            <div className="create-timesheet edit-invoice-wrapper invoice-view-master__wrapper" id="invoice-view-master__wrapper">
                <div className="another-x-wrapper">
                    <h3 className="close-create-timesheet-x" onClick={() => tryToClose("create-timesheet-wrapper")}>X</h3>
                </div>
                <div className="invoice-header-section">
                  <div className="header-words-section but-make-it-on-the-left">
                    <img className="invoice-school-logo" src={schoolLogoURL}/>
                    {familyInfoPopup && <div className="family-info-popup">{onboardDate}{currentActiveStudents.length > 0 && currentActiveStudents.map((student) => <p key={student} className="student-name-in-family-info-popup">{student}</p>)}</div>}
                  </div>
                  <div className="header-words-section">
                    <div className="invoice-header-title-invoice">INVOICE</div>
                    <div className="invoice-header-title-school-name">{schoolName}</div>
                    <div>{schoolLocation}</div>
                    <div className="invoice-header-title-country">United States</div>
                    <div>{schoolPhoneNumber}</div>
                    <div>{schoolWebsite}</div>
                  </div>
                </div>
                {familyInfo &&<div className="bill-to-section-left-side">
                  <div className="bill-to-section-left-bill-to">Bill to</div>
                  <div className="bill-to-section-left-family-name" onMouseEnter={() => toggleFamilyPopup(true)} onMouseLeave={() => toggleFamilyPopup(false)}>{props.invoice.familyName}</div>
                  <div className="bill-to-section-left-first-name">{familyInfo.primaryParentName} {props.invoice.familyName}</div>
                  <div className="bill-to-section-left-address">{familyInfo.address.addressLine1} {familyInfo.address.city} {familyInfo.address.state}</div>
                  <div className="bill-to-section-left-cellphone">{familyInfo.primaryCellphone}</div>
                  <div className="bill-to-section-left-primary-email">{familyInfo.primaryEmail}</div>
                </div>}
                <div className="bill-to-section-right-side">
                  <div className="bill-to-section-right-invoice-id"><strong>Invoice ID:</strong> {props.invoice.invoiceId}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Invoice For:</strong> {props.invoice.monthYear}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Invoice Date:</strong> {invoiceDate}</div>
                  <div className="bill-to-section-right-invoice-date"><strong>Payment Due:</strong> {paymentDue}</div>
                  <div className="bill-to-section-right-amount-due"><strong>Amount Due: (USD): ${estimateCharge()}</strong></div>
                  {
                    props.invoice.status === 'In Wave' ? <div className="bill-to-section-right-in-wave">{props.invoice.status}</div>
                    : <div className="bill-to-section-right-status-submitted">{props.invoice.status}</div>
                  }
                </div>
                <div className="invoice-lesson-header">Lessons</div>
                <div className="family-card-section-for-invoice">
                    {props.invoice.lessonsToBeBilled.map((less, index) => 
                      <div key={less.id} className="edit-invoice-lesson-strip">
                          <p className="choose-student-input-dropdown invoice-view-master__student-name">{less.studentName}</p>
                          <p className="month-number-p">{props.invoice.monthNumber}/</p><input className="invoice-edit-enter-date" value={less.date} />
                          <select className='lessons-length__new-dropdown' value={less.lessonLength}>
                            <option value={15}>15 min</option>
                            <option value={30}>30 min</option>
                            <option value={45}>45 min</option>
                            <option value={60}>60 min</option>
                            <option value={31}>30 min Intro</option>
                            <option value={46}>45 min Intro</option>
                            <option value={61}>60 min Intro</option>
                          </select>
                          <p>$</p><input className="invoice-edit-enter-date" value={findStudentRate(less.studentName, less.lessonLength)} />
                      </div>
                    )}
                </div>
                {props.invoice.extrasToBeBilled.length > 0 && <div className="invoice-lesson-header">Extras (not added to Wave!)</div>}
                <div className="family-card-section-for-invoice-extras">
                    {props.invoice.extrasToBeBilled.map((extra, index) => 
                    <div key={extra.id} className="edit-invoice-lesson-strip">
                        <p>{extra.description}</p>
                        <p>${extra.amount}</p>
                    </div>
                    )}
                </div>
                <div className="create-timesheet-bottom-sections">
                    <h3 className="create-timesheet__estimated-pay">Estimate Charge: ${estimateCharge()}</h3>

                </div>
            </div>
        </div>
    )
}
export default InvoiceViewMaster